export interface WaterReceived {
    data: {
        irrigation: number;
        precipitation: number;
        time: string;
    }[];
    forecast_date: string;
    name: string;
}

export interface ProbeSimulation {
    data: {
        fhc: number;
        swc_005cm: number;
        swc_015cm: number;
        swc_030cm: number;
        swc_060cm: number;
        time: string;
        wp: number;
    }[];
    forecast_date: string;
    name: string;
}

export interface CropWaterUse {
    data: {
        et_estimate: number;
        et_over: number;
        et_under: number;
        time: string;
    }[];
    forecast_date: string;
    name: string;
}

export interface LAIQuantiles {
    data: {
        lai_masked_a: null | number;
        lai_masked_b: null | number;
        lai_masked_w: null | number;
        time: string;
    }[];
    name: string;
}

export interface WaterRiskZones {
    data: {
        fhc: number;
        rtsml_b: number;
        rtsml_t: number;
        swc_est: null | number;
        swc_sig_over: null | number;
        swc_sig_under: null | number;
        time: string;
        to_7day_target: null | number;
        to_full_profile: null | number;
        wp: number;
    }[];
    forecast_date: string;
    name: string;
    irrigation_recommendation: boolean;
}

export interface WaterRisks {
    data: {
        time: string;
        leach_risk: number;
        water_risk: number;
    }[];
    forecast_date: string;
    name: string;
}

export enum MoistureStatus {
    APPROACHING_SATURATION = "Approaching Saturation",
    OPTIMAL = "Optimal",
    APPROCHING_DEFICIENCY = "Approaching Deficiency",
}

export interface NaveField {
    id: number;
    nave_id: string;
    expectedRain: number;
    expectedRainRisk: number;
    cumulativeIrrigation: number;
    cumulativeEffectivePrecipitation: number;
    water_estimate: NaveWaterEstimate;
}

export interface NaveWaterEstimate {
    id: number;
    date: string;
    field_capacity: number;
    upper_optimal_bound: number;
    lower_optimal_bound: number;
    soil_moisture: MoistureStatus;
    deficit_forecast: number;
    moisture_status: string;
    moisture_status_forecast: string;
    deficit: number;
    capacity_percentage: number;
}

export interface SoilMoistureCorrection {
    date: string;
    observed_soil_moisture: number;
}
